import menu from './zh-TW/menu';
import pages from './zh-TW/pages';

export default {
  'navBar.lang': '語言',
  ...menu,
  ...pages,
};
